import { PortalData } from "@portal/assets/values/Values";

export const IsValidMonthlyAmount = (amount: number) => {
  return amount >= PortalData.MINIMUM_MONTHLY_AMOUNT || amount === 0;
};
